<!-- movable-window.component.html -->
<div *ngIf="isOpen" class="movable-window" [style.left.px]="position.x" [style.top.px]="position.y">
  <div class="window-header" (mousedown)="startDrag($event)">
    {{ title }}
    <button class="close-button" (click)="close()">×</button>
  </div>
  <div class="window-content">
    <ng-content></ng-content>
  </div>
</div>